const defaultSearchFilters = {
    searchFor: 'VIN8',
    days: 'DURATION',
    searchText: ''
};

const toSafeString = value => {
    if (value == null) {
        return '';
    }

    try {
        return String(value);
    } catch {
        return '';
    }
};

const getFilterValues = searchFilters => {
    let filterValues = searchFilters;
    let toJSON;
    try {
        toJSON = searchFilters && searchFilters.toJSON;
    } catch {
        toJSON = undefined;
    }

    if (typeof toJSON === 'function') {
        try {
            filterValues = toJSON.call(searchFilters);
        } catch {
            filterValues = {};
        }
    }

    return filterValues && typeof filterValues === 'object' ? filterValues : {};
};

const getSafeFilterValue = (filterValues, key) => {
    try {
        return filterValues[key];
    } catch {
        return undefined;
    }
};

const getRequiredFilterString = (filterValues, key, defaultValue) => {
    const value = toSafeString(getSafeFilterValue(filterValues, key));
    return value || defaultValue;
};

const getSearchFilters = searchFilters => {
    const filterValues = getFilterValues(searchFilters);
    return {
        searchFor: getRequiredFilterString(filterValues, 'searchFor', defaultSearchFilters.searchFor),
        days: getRequiredFilterString(filterValues, 'days', defaultSearchFilters.days),
        searchText: toSafeString(getSafeFilterValue(filterValues, 'searchText'))
    };
};

const normalizeClaimSearchText = searchText => {
    return toSafeString(searchText).trim();
};

const isValidClaimSearchText = searchText => {
    const claimSearchText = normalizeClaimSearchText(searchText);
    if (!/^\d+$/.test(claimSearchText)) {
        return false;
    }

    const claimId = Number(claimSearchText);
    return Number.isSafeInteger(claimId);
};

const toClaimId = searchText => {
    const claimSearchText = normalizeClaimSearchText(searchText);
    return isValidClaimSearchText(claimSearchText) ? Number(claimSearchText) : undefined;
};

module.exports = {
    defaultSearchFilters,
    getSearchFilters,
    isValidClaimSearchText,
    toClaimId
};
